import Item from '../item';

const Pricing = () =>{
  return(
    <div
    className="container-fluid division3"
    id="pricing">
      <h1 className="title-responsive text-center">
        check our plans
      </h1>
      <div className="container d-flex flex-wrap justify-content-md-between justify-content-center division2">
        <div className="col-12 col-md-6 col-lg-4 px-1 p-lg-2 p-xl-4 mt-3 row justify-content-center">
          <Item
          title="intro"
          price={19}
          features={[
            'all limited links',
            'all limited links',
            'all limited links',
            'all limited links',
            'all limited links'
          ]}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 px-1 p-lg-2 p-xl-4 mt-3 row justify-content-center">
          <Item
          pop
          title="popular"
          price={29}
          features={[
            'all limited links',
            'all limited links',
            'all limited links',
            'all limited links',
            'all limited links',
          ]}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 px-1 p-lg-2 p-xl-4 mt-3 row justify-content-center">
          <Item
          title="pro"
          price={39}
          features={[
            'all limited links',
            'all limited links',
            'all limited links',
            'all limited links',
            'all limited links',
          ]}
          />
        </div>
      </div>
    </div>
  )
}
export default Pricing;